var _g, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#fe0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h450v300H0z",
    fill: "#000095"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m225 37.5-56.25 209.928L322.428 93.75 112.5 150l209.928 56.25L168.75 52.572 225 262.5l56.25-209.928L127.572 206.25 337.5 150 127.572 93.75 281.25 247.428 225 37.5",
    fill: "#fff",
    paintOrder: "markers fill stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cy: 150,
    cx: 225,
    r: 60,
    fill: "#fff",
    stroke: "#000095",
    strokeWidth: 7.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.0b4241038481b96b833332dea93dba13.svg";
export { ForwardRef as ReactComponent };